// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"230":"7e9bab2bfab992367288","731":"8910fe38d59c9d94ffc7","843":"0e050fb44cb59c06ddf4","883":"eaae4e2cc362560d425b","954":"8bb223a5797f14bd7a16"}[chunkId] + ".js";
};